import { config } from '@services/config';
import { CustomerGetResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useGetCustomer = (customerId: string) => {
  const client = useClient();
  const result = useQuery<CustomerGetResponse, Error>({
    queryKey: customerQueryKey.getCustomer(customerId),
    queryFn: () => client.get(`customer/${customerId}`).json<CustomerGetResponse>(),
    enabled: !!customerId && customerId !== '',
    refetchOnWindowFocus: false,
    ...config,
  });
  return { ...result, customer: result.data };
};
